module.exports = __webpack_public_path__ + "static/media/down_arrow.66a188e7.svg";